import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import TasksDropdown from "../CommonForBoth/TopbarDropdown/TasksDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logoPs from "../../assets/images/logo-ps2.png";
import { withNamespaces } from 'react-i18next';
import { toggleRightSidebar } from "../../store/actions";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      high_division: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleRightbar = this.toggleRightbar.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }

  componentDidMount() {
    let u = localStorage.getItem("userData")
    let userData = JSON.parse(u);
    if (userData) {
    //   let division_level = userData.member_role.division_level
      var high_division = false
  
      if (userData.dashboardspecial_status) {
          high_division = true
      }

      // if (division_level === 'COUNTRY' ||
      //     division_level === 'DIVISION' ||
      //     division_level === 'REGION' ) {
      //     high_division = true
      // }
  
      this.setState({ ...this.state,
        high_division: high_division
      })
    }
  }

  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  toggleRightbar() {
    this.props.toggleRightSidebar();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box">
                <Link to={this.state.high_division ? "dashboard-special" : "dashboard"} className="logo logo-dark">
                  <span className="logo-sm">
                    <img style={{width: "100px", height: "50px"}} src={logoPs} alt="" height="22" /> 
                  </span>
                  <span className="logo-lg w-100 h-100">
                    <img style={{width: "100px", height: "50px"}} src={logoPs} alt="" height="19" />
                  </span>
                </Link>

                <Link to={this.state.high_division ? "dashboard-special" : "dashboard"} className="logo logo-light">
                  <span className="logo-sm">
                    <img style={{width: "100px", height: "50px"}} src={logoPs} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img style={{width: "100px", height: "50px"}} src={logoPs} alt="" height="19" />
                  </span>
                </Link>
              </div>

              <button type="button" onClick={this.toggleMenu} className="btn btn-sm px-3 font-size-16 header-item waves-effect" id="vertical-menu-btn">
                <i className='bx bx-menu font-size-18'></i>
              </button>
            </div>

            <div className="d-flex">
              <TasksDropdown 
                task_nr={this.props.task_nr}
                notif_tasks={this.props.notif_tasks}
                allTasks={this.props.allTasks}
                singleTask={this.props.singleTask}
              />
              <NotificationDropdown
                notifications={this.props.notifications} 
                seeNotification={this.props.seeNotification}
              />
              <ProfileMenu />
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(withNamespaces()(Header));
